(() => {
  const button = document.querySelector('[data-kal-scroll-top]');
  if (!button) return;

  const threshold = Number(button.dataset.showAfter) || 100;
  let ticking = false;

  const update = () => {
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollableHeight > 0 ? Math.min(100, Math.max(0, (window.scrollY / scrollableHeight) * 100)) : 0;
    button.style.setProperty('--kal-scroll-progress', `${progress}%`);
    button.hidden = window.scrollY < threshold;
    button.classList.toggle('is-visible', !button.hidden);
    ticking = false;
  };

  const scheduleUpdate = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  button.addEventListener('click', () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  update();
})();